import { render, staticRenderFns } from "./EmailReturnPage.vue?vue&type=template&id=0ef65878"
import script from "./EmailReturnPage.vue?vue&type=script&lang=js"
export * from "./EmailReturnPage.vue?vue&type=script&lang=js"
import style0 from "./EmailReturnPage.vue?vue&type=style&index=0&id=0ef65878&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports